import styled from 'styled-components';
import { IconButton } from 'ui/button';
import { colors, spacing, fontWeights } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const KeyValuePairRow = styled.div`
  align-items: flex-start;
  display: grid;
  grid-template-columns: 1fr 1fr ${pxToRem(48)};
  grid-template-areas: 'key value delete';
  grid-column-gap: ${spacing.base};
  margin-bottom: ${spacing.base};
`;

export const LightText = styled.span`
  color: ${colors.textSecondary};
  font-weight: ${fontWeights.regular};
`;

export const HeightAlignedIconButton = styled(IconButton)`
  height: ${pxToRem(42)};
`;
